import { BrowserRouter, useRoutes } from "react-router";
import { Suspense } from "react";
import ScrollToTop from "./Components/ScrollToTop";
import { publicRoutes } from "./routes/publicRoutes";

const AppRoutes = () => {
  return useRoutes(publicRoutes);
};

const App = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<p>suspense Loading...</p>}>
        <ScrollToTop />
        <AppRoutes />
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
